import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { mixpanel, constants, links } from 'common/helpers'
import cx from 'classnames'

import { WidthContainer } from 'components/_new/layout/widthContainer'
import Countdown from 'components/ui/countdown/ActiveQueueCountdown/ActiveQueueCountdown'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import Box from 'components/_new/layout/Box/Box'

import Section from '../Section/Section'
import Note from '../Note/Note'

import messages from './messages'
import s from './TimerSection.scss'


const handleClick = () => {
  mixpanel.track(constants.analyticsEvents.thankYouAddToQueue)
}

const TimerSection = ({ className, redirectLink, hasLockedProductsAfterSubscription }) => {
  const timerMessages = hasLockedProductsAfterSubscription ? messages.lockedQueue : messages.defaultQueue

  const title = redirectLink === links.makeup && !hasLockedProductsAfterSubscription
    ? timerMessages.buttonMakeupTitle
    : timerMessages.buttonTitle

  return (
    <Section className={cx(s.timerSlide, className)}>
      <WidthContainer className={cx(s.content, { [s.withoutCounter]: hasLockedProductsAfterSubscription })}>
        <Box mb="24">
          <Text
            className={s.title}
            size="38-48"
            message={timerMessages.title}
            uppercase
            semibold
          />
        </Box>
        <Note big message={timerMessages.note} />
        {
          !hasLockedProductsAfterSubscription && (
            <Countdown className={s.countdown} withDecor />
          )
        }
        <Box mt={hasLockedProductsAfterSubscription && '24'}>
          <Button
            to={redirectLink}
            color="brand"
            size="md"
            weight="normal"
            title={title}
            uppercase
            onClick={handleClick}
          />
        </Box>
      </WidthContainer>
    </Section>
  )
}

TimerSection.propTypes = {
  className: PropTypes.string,
  redirectLink: PropTypes.string,
}


export default TimerSection
